import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";

export class ChickenSwitch {
  constructor(private $log: Logger, private $util: Utils) {
    const chickenButtons: NodeListOf<HTMLElement> = document.querySelectorAll('.js-chicken-buttons');

    this.$log.debug('Found Chicken Buttons', chickenButtons)
    chickenButtons?.forEach(button => {
      this.handleAllChickens(button);
    });
  }

  private handleAllChickens(buttonElement: HTMLElement) {
    const triggerEmployee: HTMLElement = buttonElement.querySelector('.js-trigger-employee');
    const triggerChicken: HTMLElement = buttonElement.querySelector('.js-trigger-chicken');
    const chickenImages: NodeListOf<HTMLElement> = document.querySelectorAll('.js-chicken-image');
    const chickenAudio: HTMLAudioElement = buttonElement.querySelector('.js-chicken-audio');

    this.$log.debug('Found Trigger', triggerEmployee, triggerChicken);
    this.$log.debug('Found Chicken Images', chickenImages);

    triggerEmployee.addEventListener('click', () => {
      if (chickenImages) {
        this.$util.addOrRemoveClases('remove', 'display', ...chickenImages);
        this.$util.addOrRemoveClases('remove', 'active', triggerChicken);
        this.$util.addOrRemoveClases('add', 'active', triggerEmployee);
      }
    }, {passive: true});

    triggerChicken.addEventListener('click', () => {
      this.$util.addOrRemoveClases('add', 'display', ...chickenImages);
      this.$util.addOrRemoveClases('add', 'active', triggerChicken);
      this.$util.addOrRemoveClases('remove', 'active', triggerEmployee);
      chickenAudio.play();

    }, {passive: true});
  }
}
